import React from 'react';
import PropTypes from 'prop-types';
import { IconX } from '@tabler/icons-react';
import { useNotification } from 'hooks';

function NotificationItem({ title, message, timestamp, onClose }) {
	return (
		<div
			className="rounded-[--radius-lg] shadow-md w-80 overflow-hidden border"
			style={{
				background: 'var(--color-bg-primary)',
				borderColor: 'var(--color-border-subtle)',
			}}
			role="alert"
			aria-live="assertive"
			aria-atomic="true"
		>
			<div
				className="flex items-center justify-between px-4 py-2 border-b"
				style={{ borderColor: 'var(--color-border-subtle)' }}
			>
				<div className="flex items-center gap-2">
					<span className="w-2 h-2 rounded-full bg-blue-500 shrink-0" />
					<strong
						className="text-sm font-semibold"
						style={{ color: 'var(--color-text-primary)' }}
					>
						{title}
					</strong>
				</div>
				<div className="flex items-center gap-2">
					<span
						className="text-[11px]"
						style={{ color: 'var(--color-text-tertiary)' }}
					>
						{timestamp.toLocaleTimeString()}
					</span>
					<button
						type="button"
						onClick={onClose}
						className="transition-colors"
						style={{ color: 'var(--color-text-tertiary)' }}
						aria-label="Stäng"
					>
						<IconX size={14} />
					</button>
				</div>
			</div>
			<div
				className="px-4 py-2 text-sm"
				style={{ color: 'var(--color-text-secondary)' }}
			>
				{message}
			</div>
		</div>
	);
}

NotificationItem.propTypes = {
	title: PropTypes.string.isRequired,
	message: PropTypes.string.isRequired,
	timestamp: PropTypes.instanceOf(Date).isRequired,
	onClose: PropTypes.func.isRequired,
};

function Notification() {
	const { items, handleDelete } = useNotification();

	if (!items || items.length === 0) return null;

	return (
		<div
			aria-live="polite"
			aria-atomic="true"
			className="fixed top-[52px] right-4 z-50 flex flex-col gap-2 pt-2"
		>
			{items.map((item, index) => (
				<NotificationItem
					key={item.timestamp ? item.timestamp.getTime() : index}
					title={item.title}
					message={item.message}
					timestamp={item.timestamp}
					onClose={() => handleDelete(index)}
				/>
			))}
		</div>
	);
}

export default Notification;
